export default __webpack_public_path__ + "static/media/play.86b653ba.svg";